import React from 'react';
import { Proposition } from './Proposition';
import { HappyIcon } from './Icons';
import { useTranslation } from 'react-i18next';

export const HereForYouSinceProposition = () => {
  const { t } = useTranslation('common', { useSuspense: false });
  return (
    <Proposition message={t('fundraising.proposition.message.hereForYouSince')}>
      <HappyIcon />
    </Proposition>
  );
};
